import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslate } from '@tolgee/react';
import LocalizationSection from '../layout/MainLayout/Header/LocalizationSection';

const NavbarContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    background: '#fafafa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 1.5rem',
    borderBottom: '2px solid #000',
    position: 'sticky',
    top: 0,
    zIndex: 100
}));

const Logo = styled('img')({
    height: 24,
    width: 'auto',
    display: 'block'
});

const openCalendar = () => {
    window.open('https://zcal.co/i/veixFr52', '_blank', 'noopener,noreferrer');
};

const Navbar: React.FC = () => {
    const { t } = useTranslate();
    return (
        <NavbarContainer>
            <Logo src={require('../assets/images/LogoFrust.png')} alt="frUst logo" />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <LocalizationSection />
                <Box
                    sx={{
                        background: '#ef11e9',
                        color: '#fff',
                        border: '2px solid #000',
                        borderRadius: '8px',
                        fontWeight: 700,
                        fontSize: 18,
                        padding: '0.5rem 1.5rem',
                        filter: 'drop-shadow(2px 2px 0 #000)',
                        transition: 'background 0.2s',
                        '&:hover': { background: '#000', color: '#fff', filter: 'none' }
                    }}
                    onClick={openCalendar}
                >
                    {t('pdf_success.button.start_saving')}
                </Box>
            </Box>
        </NavbarContainer>
    );
};

export default Navbar;
